import { BCMSRecord, BCMSStateManagerCRUD, useBCMSContext } from "@bcm-dev/bcms-vite";
import TemplateDetailsPage, { getDefaultData, getDefaultUI } from 'components/pages/TemplateDetailsPage';
import Classes from "model";

export default function CaptureAddNewTypeModalSECDDOpen(props) {
  const context = useBCMSContext();
  BCMSRecord.globalControllerFor(Classes, context);

  const data = BCMSStateManagerCRUD.init(getDefaultData())
    .update(["template", "transactionType"], "payment")
    .update([ "template", "secCode" ], "PPD Credit - Consumer Credit")
    .submit();

  const ui = BCMSStateManagerCRUD.init(getDefaultUI())
    .update(["secCodeSelectIsActive", "isActive"], true)
    .submit();

  return (
    <TemplateDetailsPage data={data} ui={ui} />
  )
}
